import { SearchResult, SearchSectionId } from '../types';
import { getMatchFunction, calculateRelevanceScore } from '../utils';

/**
 * Search Berichte (Reports)
 * Currently returns static navigation items
 */
export async function searchBerichte(
  term: string, 
  limit: number, 
  exactMatch: boolean,
  fuzzyMatch: boolean = false,
  signal?: AbortSignal
): Promise<SearchResult[]> {
  if (!term.trim()) return [];
  
  const matchFn = getMatchFunction(exactMatch, fuzzyMatch);
  
  // Static report entries
  const berichte = [
    { id: 'umsatzstatistik', title: 'Umsatzstatistik', subtitle: 'Umsätze nach Zeitraum' },
    { id: 'provisionsauswertung', title: 'Provisionsauswertung', subtitle: 'Provisionen nach Partner' },
    { id: 'kundenstatistik', title: 'Kundenstatistik', subtitle: 'Kundenanalyse' },
    { id: 'vertragsstatistik', title: 'Vertragsstatistik', subtitle: 'Verträge nach Sparte' },
  ];
  
  return berichte
    .filter(b => matchFn(term, b.title, b.subtitle))
    .slice(0, limit)
    .map(b => ({
      id: b.id,
      type: 'berichte' as SearchSectionId,
      title: b.title,
      subtitle: b.subtitle,
      badge: 'Bericht',
      data: b,
      relevanceScore: calculateRelevanceScore(term, b.title, b.subtitle)
    }));
}
